import { Box, useTheme } from '@mui/material';

function InvalidDay() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: 120,
        bgcolor: 'action.hover',
        borderRadius: 1,
        border: `1px solid ${theme.palette.divider}`,
      }}
    />
  );
}

export default InvalidDay;
